// loads polyfill on IE11 only per usage instructions at https://github.com/jhildenbiddle/css-vars-ponyfill

window.MSInputMethodContext && document.documentMode && document.write('<script src="https://cdn.jsdelivr.net/npm/css-vars-ponyfill@2"></script>');
